import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFlickrComponent } from './simple-icons-flickr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFlickrComponent ],
    exports:      [ SimpleIconsFlickrComponent ],
    bootstrap:    []
})
export class SimpleIconsFlickrModule {}
